import { fetchPost } from 'common';

const apiUri: string = process.env.REACT_APP_API_URI as string;

export const getTaxBillRecord = (body: any, bearerToken: string) => {
  return fetchPost(`${apiUri}/taxtrax/taxbillrecord`, body, bearerToken);
};

export const exportTaxBillRecord = (
  body: any,
  bearerToken: string,
  format: string,
) =>
  fetchPost(
    `${apiUri}/taxtrax/taxbillrecord/export/${format}`,
    body,
    bearerToken,
  );

export const downloadTaxBill = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/taxtrax/taxbillrecord/download`, body, bearerToken);
